export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
     * @description 字典列表
     * @description http://yapi.xiya.vip/project/11/interface/api/75
     */
    DICT_ALL: function DICT_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/dict/index',
        method: 'post',
        data: query
      });
    },

    /**
     * @description 字典创建
     * @description http://yapi.xiya.vip/project/11/interface/api/80
     */
    DICT_CREATE: function DICT_CREATE(data) {
      return request({
        url: '/api/dict/create',
        method: 'put',
        data: data
      });
    },

    /**
     * @description 字典详情
     * @description http://yapi.xiya.vip/project/11/interface/api/95
     */
    DICT_DETAIL: function DICT_DETAIL(id) {
      return request({
        url: '/api/dict/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
     * @description 字典编辑
     * @description http://yapi.xiya.vip/project/11/interface/api/95
     */
    DICT_UPDATE: function DICT_UPDATE(data) {
      return request({
        url: '/api/dict/update',
        method: 'put',
        data: data
      });
    },

    /**
     * @description 字典删除
     * @description http://yapi.xiya.vip/project/11/interface/api/90
     */
    DICT_DELETE: function DICT_DELETE(id) {
      return request({
        url: '/api/dict/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});